<template>
  <div class=" w-full ">
    <div class=" relative  w-full">
      <input
        id="search"
        v-model="search"
        type="text"
        :placeholder="'Buscar '+label+'...'"
        class="p-2  w-full border border-gray-300 rounded"
        @input="searchDataFilter(search)"
      >

      <ul
        v-if="searchData.length"
        class="w-full rounded bg-white border border-gray-300 px-4 py-2 space-y-1 absolute z-30"
      >
        <li
          v-for="sel in searchData"
          :key="sel.name"
          class="cursor-pointer hover:bg-gray-100 p-1 z-30"
          @click="selectRow(sel)"
        >
          <div class=" w-full flex  flex-wrap justify-start overflow-x-hidden">
            <span class="text-xs font-extrabold text-blue-900 w-full"> {{ sel.name  }} / {{sel.role}}</span>
          
          </div>
        </li>
      </ul>

      <div
        v-if="seleccionado"
        class="font-extrabold pt-1 text-start w-full justify-start flex text-xs px-2"
      >

      {{ CapitalizeTo(label) }} seleccionado <span class="font-semibold text-blue-500 text-start text-xs"> : {{ seleccionado.hasOwnProperty('nombre')?seleccionado.nombre:seleccionado.name+' '+seleccionado.email+' '+seleccionado.phone }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import generales from '@/functions/generales'
import {
    ref,
    computed,
    defineEmits
} from 'vue'
 //import { defineProps, useContext } from 'vue'
   
export default {
    mixins:[generales],
    props: {
       
        rows: {
            type: Array,

        },
        label: {
            type: String,
            default:''

        },
        valor:{
            type:Object
        }
    },
    //emits:'seleccionado',
    setup(props,{ emit }) {
      //let emit  = defineEmits(['seleccionado'])
        let search = ref('')
        const searchData = computed(() => {
            if (search.value === '') {
                return []
            }
           
           if(props.rows){
            return props.rows.filter(country => {
                //if (String(country.nombre).toLowerCase().includes(search.value.toLowerCase()) && matches < 10) {
                    
                    return country
                //}
            })
           }else{
            return [];
           }
           
        });
      
        const selectRow = (country) => {
            seleccionado.value = country
            search.value = ''
             emit("seleccionado", seleccionado)
        }
        const searchDataFilter = (query) => {
            
             emit("search", query)
        }
        let seleccionado = ref(props.valor)
        return {
           emit,
            search,
            searchData,
            searchDataFilter,
            selectRow,
            seleccionado
        }
    },
    mounted(){

    }
}
</script>
